import { GetHospitalUserCredentials } from '../adapters/HospitalDashboard/GetHospitalUserCredentials';
import { UpdateUserPassword } from '../adapters/HospitalDashboard/UpdateUserPassword';

const getApiErrorMessage = (res, fallback) =>
  res?.data?.error?.message ||
  res?.data?.message ||
  res?.data?.data?.message ||
  fallback;

export const fetchHospitalUserCredentials = (hospitalId) => {
  return new Promise((resolve, reject) => {
    GetHospitalUserCredentials(hospitalId)
      .then((res) => {
        if (res?.data && (res.status === 200 || res.status === 201)) {
          resolve(res.data);
        } else {
          reject(getApiErrorMessage(res, 'Error fetching hospital user credentials'));
        }
      })
      .catch((err) => {
        reject(
          err?.response?.data?.error?.message ||
          err?.response?.data?.message ||
          err?.message ||
          'Error fetching hospital user credentials'
        );
      });
  });
};

export const updateUserPassword = ({ userId, password }) => {
  return new Promise((resolve, reject) => {
    UpdateUserPassword({ user_id: userId, password })
      .then((res) => {
        if (res?.data && (res.status === 200 || res.status === 201)) {
          resolve(res.data);
        } else {
          reject(getApiErrorMessage(res, 'Error updating password'));
        }
      })
      .catch((err) => {
        reject(
          err?.response?.data?.error?.message ||
          err?.response?.data?.message ||
          err?.message ||
          'Error updating password'
        );
      });
  });
};
